'use es6';

import { createAction } from 'flux-actions';
import { DISMISS_ATTACHMENTS_ERROR } from '../constants/fileUploadsActionTypes';
export const dismissAttachmentsError = createAction(DISMISS_ATTACHMENTS_ERROR, ({
  threadId
}) => ({
  threadId
}));